import React, { useState, useRef } from "react";
import { Text, Image, Link, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import ImageInBackground from "./ImageInBackground";
import { authentication, authenticationUrl } from "../api/authentication";
import styles from "../style/layout_components/Loginbanner.module.scss";
import { Redirect } from "react-router-dom";
import { Button } from "../components/buttons/Button";

const LoginBanner = (props) => {
  const [href, setHref] = useState(undefined);
  const executeForm = useRef(null);

  function loginCall(e, provider) {
    executeLogin(provider, (response) => {
      setHref(authenticationUrl(response.href));
      executeForm.current.submit();
    });
  }

  if (props.sitecoreContext?.user && props.fields?.authenticatedLink) {
    return <Redirect to={{ pathname: props.fields.authenticatedLink.value.href }} />;
  }

  return (
    <div className={styles.loginWrap}>
      <ImageInBackground className={styles.LoginImage} imageUrl={props.fields.image.value.src}></ImageInBackground>
      <div className={styles.loginPanel}>
        <div className={styles.loginActions}>
          <h2>
            <Text field={props.fields.heading} />
          </h2>
          <div className={styles.loginButtonsWrapper}>
            <Button
              leading={<Image className={styles.loginButtonImage} field={props.fields.loginButtonIcon} />}
              onClick={(e) => loginCall(e, "eherkenning")}
            >
              {props.fields.loginButtonEherkenningText.value}
            </Button>

            {props.fields.loginButtonAzureADB2CText.value && (
              <Button
                leading={<i className={`${styles.loginUsernameButtonIcon} icon-unlock`} />}
                onClick={(e) => loginCall(e, "azureadb2c")}
              >
                {props.fields.loginButtonAzureADB2CText.value}
              </Button>
            )}
          </div>

          <p>
            <Link field={props.fields.helpLink}></Link>
          </p>
        </div>
        <div className={styles.loginDescription}>
          <Image field={props.fields.eHerkenningImage}></Image>
          <p>
            <Text field={props.fields.loginDescription}></Text>
          </p>
        </div>
      </div>
      <form ref={executeForm} method="post" action={href}>
        <input type="submit" style={{ display: "none" }} />
      </form>
    </div>
  );
};

export default withSitecoreContext()(LoginBanner);

async function executeLogin(provider, callback) {
  const response = await authentication(provider);
  callback(response);
}
